import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { customerPointSettingQueries } from '@/services/pointConfiguration/pointConfiguration.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useManageCustomerPointSetting = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('managePointSetting', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: customerPointSettingQueries.all() });
    },
    onError: (err: {
      data?: {
        errors?: { errorMessage: string }[];
      };
    }) => {
      toast.error(err?.data?.errors?.[0].errorMessage);
    },
  });
  return { mutateAsync, isPending };
};

export default useManageCustomerPointSetting;
